

// import React, { useEffect, useState } from "react";
// import axiosAuth from "../../api/axiosAuth";
// import "../../style/DirectorGrupo.css";

// export default function DirectorGrupo() {
//   const [loading, setLoading] = useState(false);

//   const [sedes, setSedes] = useState([]);
//   const [profesores, setProfesores] = useState([]);
//   const [grados, setGrados] = useState([]);
//   const [directores, setDirectores] = useState([]);

//   const [form, setForm] = useState({
//     sede_id: "",
//     profesor_id: "",
//     grado: "",
//     grupo: "",

//     puede_notas: true,
//     puede_asistencia: true,
//     puede_observador: true,
//     puede_convivencia: true,
//     puede_financiero: false,
//     puede_certificados: false,
//   });

//   /* =====================================
//      CARGA INICIAL
//   ===================================== */

//   useEffect(() => {
//     cargarSedes();
//     cargarDirectores();
//   }, []);

//   /* =====================================
//      OBTENER SEDES
//   ===================================== */

//   const cargarSedes = async () => {
//     try {
//       const { data } = await axiosAuth.get(
//         "/directores-grupo/sedes"
//       );

//       setSedes(
//         Array.isArray(data)
//           ? data
//           : data?.sedes || []
//       );

//     } catch (error) {
//       console.error(error);

//       alert("Error cargando sedes");
//     }
//   };

//   /* =====================================
//      OBTENER DIRECTORES
//   ===================================== */

//   const cargarDirectores = async () => {
//     try {
//       setLoading(true);

//       const { data } = await axiosAuth.get(
//         "/directores-grupo"
//       );

//       setDirectores(
//         Array.isArray(data)
//           ? data
//           : data?.directores || []
//       );

//     } catch (error) {
//       console.error(error);

//       alert("Error cargando directores");

//     } finally {
//       setLoading(false);
//     }
//   };

//   /* =====================================
//      CAMBIAR SEDE
//   ===================================== */

//   const handleSedeChange = async (e) => {

//     const sede_id = e.target.value;

//     setForm((prev) => ({
//       ...prev,
//       sede_id,
//       profesor_id: "",
//       grado: "",
//       grupo: "",
//     }));

//     if (!sede_id) {

//       setProfesores([]);
//       setGrados([]);

//       return;
//     }

//     try {

//       const [profesoresRes, gradosRes] =
//         await Promise.all([

//           axiosAuth.get(
//             `/directores-grupo/profesores/${sede_id}`
//           ),

//           axiosAuth.get(
//             `/directores-grupo/grados/${sede_id}`
//           ),

//         ]);

//       /* =====================
//          PROFESORES
//       ===================== */

//       const profesoresData =
//         profesoresRes.data;

//       setProfesores(

//         Array.isArray(profesoresData)

//           ? profesoresData

//           : profesoresData?.profesores || []

//       );

//       /* =====================
//          GRADOS
//       ===================== */

//       const gradosData =
//         gradosRes.data;

//       setGrados(

//         Array.isArray(gradosData)

//           ? gradosData

//           : gradosData?.grados || []

//       );

//     } catch (error) {

//       console.error(error);

//       setProfesores([]);
//       setGrados([]);

//       alert(
//         "Error cargando profesores y grados"
//       );
//     }
//   };

//   /* =====================================
//      CHECKBOX
//   ===================================== */

//   const handleCheck = (campo) => {

//     setForm((prev) => ({
//       ...prev,
//       [campo]: !prev[campo],
//     }));
//   };

//   /* =====================================
//      GUARDAR
//   ===================================== */

//   const guardar = async () => {

//     try {

//       if (!form.sede_id) {
//         return alert(
//           "Seleccione una sede"
//         );
//       }

//       if (!form.profesor_id) {
//         return alert(
//           "Seleccione un profesor"
//         );
//       }

//       if (
//         !form.grado ||
//         !form.grupo
//       ) {
//         return alert(
//           "Seleccione un grupo"
//         );
//       }

//       await axiosAuth.post(
//         "/directores-grupo",
//         form
//       );

//       alert(
//         "✅ Director asignado correctamente"
//       );

//       setForm({

//         sede_id: "",
//         profesor_id: "",
//         grado: "",
//         grupo: "",

//         puede_notas: true,
//         puede_asistencia: true,
//         puede_observador: true,
//         puede_convivencia: true,
//         puede_financiero: false,
//         puede_certificados: false,

//       });

//       setProfesores([]);
//       setGrados([]);

//       cargarDirectores();

//     } catch (error) {

//       console.error(error);

//       alert(

//         error?.response?.data?.message ||

//         "Error guardando"

//       );
//     }
//   };

//   /* =====================================
//      ELIMINAR
//   ===================================== */

//   const eliminar = async (id) => {

//     const ok = window.confirm(
//       "¿Eliminar director de grupo?"
//     );

//     if (!ok) return;

//     try {

//       await axiosAuth.delete(
//         `/directores-grupo/${id}`
//       );

//       cargarDirectores();

//     } catch (error) {

//       console.error(error);

//       alert(

//         error?.response?.data?.message ||

//         "Error eliminando"

//       );
//     }
//   };

//   return (

//     <div className="director-container">

//       <div className="director-header">

//         <h2>👨‍🏫 Director de Grupo</h2>

//       </div>

//       {/* FORMULARIO */}

//       <div className="director-card">

//         <h3>Nueva Asignación</h3>

//         <div className="director-grid">

//           {/* SEDE */}

//           <div>

//             <label>Sede</label>

//             <select
//               value={form.sede_id}
//               onChange={handleSedeChange}
//             >

//               <option value="">
//                 Seleccione
//               </option>

//               {sedes.map((s) => (

//                 <option
//                   key={s.id}
//                   value={s.id}
//                 >
//                   {s.nombre}
//                 </option>

//               ))}

//             </select>

//           </div>

//           {/* PROFESOR */}

//           <div>

//             <label>Profesor</label>

//             <select

//               value={form.profesor_id}

//               onChange={(e) =>

//                 setForm((prev) => ({

//                   ...prev,

//                   profesor_id:
//                     e.target.value,

//                 }))

//               }

//             >

//               <option value="">
//                 Seleccione
//               </option>

//               {profesores.map((p) => (

//                 <option
//                   key={p.id}
//                   value={p.id}
//                 >

//                   {p.nombre} {p.apellido}

//                 </option>

//               ))}

//             </select>

//           </div>

//           {/* GRADO */}

//           <div>

//             <label>Grado / Grupo</label>

//             <select

//               value={

//                 form.grado &&
//                 form.grupo

//                   ? `${form.grado}-${form.grupo}`

//                   : ""

//               }

//               onChange={(e) => {

//                 const [grado, grupo] =

//                   e.target.value.split("-");

//                 setForm((prev) => ({

//                   ...prev,

//                   grado,

//                   grupo,

//                 }));
//               }}

//             >

//               <option value="">
//                 Seleccione
//               </option>

//               {grados.map((g, index) => (

//                 <option

//                   key={index}

//                   value={`${g.grado}-${g.grupo}`}

//                 >

//                   {g.grado}° {g.grupo}

//                 </option>

//               ))}

//             </select>

//           </div>

//         </div>

//         {/* PERMISOS */}

//         <h4 className="permiso-title">

//           Permisos del Director

//         </h4>

//         <div className="permisos-grid">

//           <label>

//             <input

//               type="checkbox"

//               checked={form.puede_notas}

//               onChange={() =>

//                 handleCheck(
//                   "puede_notas"
//                 )

//               }

//             />

//             Ver Notas

//           </label>

//           <label>

//             <input

//               type="checkbox"

//               checked={
//                 form.puede_asistencia
//               }

//               onChange={() =>

//                 handleCheck(
//                   "puede_asistencia"
//                 )

//               }

//             />

//             Asistencia

//           </label>

//           <label>

//             <input

//               type="checkbox"

//               checked={
//                 form.puede_observador
//               }

//               onChange={() =>

//                 handleCheck(
//                   "puede_observador"
//                 )

//               }

//             />

//             Observador

//           </label>

//           <label>

//             <input

//               type="checkbox"

//               checked={
//                 form.puede_convivencia
//               }

//               onChange={() =>

//                 handleCheck(
//                   "puede_convivencia"
//                 )

//               }

//             />

//             Convivencia

//           </label>

//           <label>

//             <input

//               type="checkbox"

//               checked={
//                 form.puede_financiero
//               }

//               onChange={() =>

//                 handleCheck(
//                   "puede_financiero"
//                 )

//               }

//             />

//             Financiero

//           </label>

//           <label>

//             <input

//               type="checkbox"

//               checked={
//                 form.puede_certificados
//               }

//               onChange={() =>

//                 handleCheck(
//                   "puede_certificados"
//                 )

//               }

//             />

//             Certificados

//           </label>

//         </div>

//         <div className="director-actions">

//           <button

//             className="btn-guardar"

//             onClick={guardar}

//           >

//             💾 Guardar Asignación

//           </button>

//         </div>

//       </div>

//       {/* TABLA */}

//       <div className="director-card">

//         <h3>Directores Asignados</h3>

//         {loading ? (

//           <p>Cargando...</p>

//         ) : (

//           <div className="table-responsive">

//             <table className="director-table">

//               <thead>

//                 <tr>

//                   <th>Profesor</th>

//                   <th>Sede</th>

//                   <th>Grado</th>

//                   <th>Grupo</th>

//                   <th>Permisos</th>

//                   <th>Acción</th>

//                 </tr>

//               </thead>

//               <tbody>

//                 {directores.map((d) => (

//                   <tr key={d.id}>

//                     <td>

//                       {d.nombre} {d.apellido}

//                     </td>

//                     <td>{d.sede_nombre}</td>

//                     <td>{d.grado}</td>

//                     <td>{d.grupo}</td>

//                     <td>

//                       {d.puede_notas === 1 && "📚 "}

//                       {d.puede_asistencia === 1 && "📅 "}

//                       {d.puede_observador === 1 && "📝 "}

//                       {d.puede_convivencia === 1 && "⚖️ "}

//                       {d.puede_financiero === 1 && "💰 "}

//                       {d.puede_certificados === 1 && "📄 "}

//                     </td>

//                     <td>

//                       <button

//                         className="btn-eliminar"

//                         onClick={() =>

//                           eliminar(d.id)

//                         }

//                       >

//                         🗑 Eliminar

//                       </button>

//                     </td>

//                   </tr>

//                 ))}

//                 {!directores.length && (

//                   <tr>

//                     <td

//                       colSpan="6"

//                       style={{
//                         textAlign: "center",
//                       }}

//                     >

//                       No hay directores asignados

//                     </td>

//                   </tr>

//                 )}

//               </tbody>

//             </table>

//           </div>

//         )}

//       </div>

//     </div>
//   );
// }

//

import React, { useEffect, useState } from "react";
import axiosAuth from "../../api/axiosAuth";
import "../../style/DirectorGrupo.css";

export default function DirectorGrupo() {

  const [loading, setLoading] = useState(false);

  const [sedes, setSedes] = useState([]);
  const [profesores, setProfesores] = useState([]);
  const [grados, setGrados] = useState([]);
  const [directores, setDirectores] = useState([]);

  const [editando, setEditando] = useState(null);

  const [form, setForm] = useState({

    sede_id: "",
    profesor_id: "",
    grado: "",
    grupo: "",

    puede_notas: true,
    puede_asistencia: true,
    puede_observador: true,
    puede_convivencia: true,
    puede_financiero: false,
    puede_certificados: false,

  });

  /* ==========================
     CARGA INICIAL
  ========================== */

  useEffect(() => {

    cargarSedes();
    cargarDirectores();

  }, []);

  /* ==========================
     SEDES
  ========================== */

  const cargarSedes = async () => {

    try {

      const { data } = await axiosAuth.get(
        "/directores-grupo/sedes"
      );

      setSedes(

        Array.isArray(data)

          ? data

          : data?.sedes || []

      );

    } catch (error) {

      console.error(error);

      alert("Error cargando sedes");

    }
  };

  /* ==========================
     DIRECTORES
  ========================== */

  const cargarDirectores = async () => {

    try {

      setLoading(true);

      const { data } = await axiosAuth.get(
        "/directores-grupo"
      );

      setDirectores(

        Array.isArray(data)

          ? data

          : data?.directores || []

      );

    } catch (error) {

      console.error(error);

      alert("Error cargando directores");

    } finally {

      setLoading(false);

    }
  };

  /* ==========================
     CAMBIAR SEDE
  ========================== */

  const handleSedeChange = async (e) => {

    const sede_id = e.target.value;

    setForm((prev) => ({

      ...prev,

      sede_id,

      profesor_id: "",

      grado: "",

      grupo: "",

    }));

    if (!sede_id) {

      setProfesores([]);
      setGrados([]);

      return;
    }

    try {

      const [profRes, gradosRes] = await Promise.all([

        axiosAuth.get(
          `/directores-grupo/profesores/${sede_id}`
        ),

        axiosAuth.get(
          `/directores-grupo/grados/${sede_id}`
        ),

      ]);

      /* PROFESORES */

      setProfesores(

        Array.isArray(profRes.data)

          ? profRes.data

          : profRes.data?.profesores || []

      );

      /* GRADOS */

      setGrados(

        Array.isArray(gradosRes.data)

          ? gradosRes.data

          : gradosRes.data?.grados || []

      );

    } catch (error) {

      console.error(error);

      setProfesores([]);
      setGrados([]);

      alert(
        "Error cargando profesores y grados"
      );

    }
  };

  /* ==========================
     CHECK
  ========================== */

  const handleCheck = (campo) => {

    setForm((prev) => ({

      ...prev,

      [campo]: !prev[campo],

    }));
  };

  /* ==========================
     GUARDAR
  ========================== */

  const guardar = async () => {

    try {

      if (!form.sede_id) {

        return alert(
          "Seleccione una sede"
        );
      }

      if (!form.profesor_id) {

        return alert(
          "Seleccione un profesor"
        );
      }

      if (!form.grado || !form.grupo) {

        return alert(
          "Seleccione un grupo"
        );
      }

      await axiosAuth.post(
        "/directores-grupo",
        form
      );

      alert(
        "✅ Director asignado correctamente"
      );

      setForm({

        sede_id: "",
        profesor_id: "",
        grado: "",
        grupo: "",

        puede_notas: true,
        puede_asistencia: true,
        puede_observador: true,
        puede_convivencia: true,
        puede_financiero: false,
        puede_certificados: false,

      });

      setProfesores([]);
      setGrados([]);

      cargarDirectores();

    } catch (error) {

      console.error(error);

      alert(

        error?.response?.data?.message ||

        "Error guardando"

      );
    }
  };

  /* ==========================
     ELIMINAR
  ========================== */

  const eliminar = async (id) => {

    const ok = window.confirm(
      "¿Eliminar director?"
    );

    if (!ok) return;

    try {

      await axiosAuth.delete(
        `/directores-grupo/${id}`
      );

      cargarDirectores();

    } catch (error) {

      console.error(error);

      alert("Error eliminando");

    }
  };

  /* ==========================
     EDITAR PERMISOS
  ========================== */

  const editarPermisos = (director) => {

    setEditando({

      id: director.id,

      puede_notas: !!director.puede_notas,

      puede_asistencia: !!director.puede_asistencia,

      puede_observador: !!director.puede_observador,

      puede_convivencia: !!director.puede_convivencia,

      puede_financiero: !!director.puede_financiero,

      puede_certificados: !!director.puede_certificados,

    });
  };

  const guardarPermisos = async () => {

    try {

      await axiosAuth.put(

        `/directores-grupo/${editando.id}/permisos`,

        editando

      );

      alert(
        "✅ Permisos actualizados"
      );

      setEditando(null);

      cargarDirectores();

    } catch (error) {

      console.error(error);

      alert(
        "Error actualizando permisos"
      );
    }
  };

  return (

    <div className="director-container">

      <div className="director-header">

        <h2>👨‍🏫 Director de Grupo</h2>

      </div>

      {/* FORMULARIO */}

      <div className="director-card">

        <h3>Nueva Asignación</h3>

        <div className="director-grid">

          <div>

            <label>Sede</label>

            <select

              value={form.sede_id}

              onChange={handleSedeChange}

            >

              <option value="">
                Seleccione
              </option>

              {sedes.map((s) => (

                <option

                  key={s.id}

                  value={s.id}

                >

                  {s.nombre}

                </option>

              ))}

            </select>

          </div>

          <div>

            <label>Profesor</label>

            <select

              value={form.profesor_id}

              onChange={(e) =>

                setForm((prev) => ({

                  ...prev,

                  profesor_id: e.target.value,

                }))

              }

            >

              <option value="">
                Seleccione
              </option>

              {profesores.map((p) => (

                <option

                  key={p.id}

                  value={p.id}

                >

                  {p.nombre} {p.apellido}

                </option>

              ))}

            </select>

          </div>

          <div>

            <label>Grado / Grupo</label>

            <select

              value={

                form.grado && form.grupo

                  ? `${form.grado}-${form.grupo}`

                  : ""

              }

              onChange={(e) => {

                const [grado, grupo] =

                  e.target.value.split("-");

                setForm((prev) => ({

                  ...prev,

                  grado,

                  grupo,

                }));

              }}

            >

              <option value="">
                Seleccione
              </option>

              {grados.map((g, index) => (

                <option

                  key={index}

                  value={`${g.grado}-${g.grupo}`}

                >

                  {g.grado}° {g.grupo}

                </option>

              ))}

            </select>

          </div>

        </div>

        <div className="director-actions">

          <button

            className="btn-guardar"

            onClick={guardar}

          >

            💾 Guardar

          </button>

        </div>

      </div>

      {/* TABLA */}

      <div className="director-card">

        <h3>Directores Asignados</h3>

        {loading ? (

          <p>Cargando...</p>

        ) : (

          <div className="table-responsive">

            <table className="director-table">

              <thead>

                <tr>

                  <th>Profesor</th>

                  <th>Sede</th>

                  <th>Grado</th>

                  <th>Grupo</th>

                  <th>Permisos</th>

                  <th>Acciones</th>

                </tr>

              </thead>

              <tbody>

                {directores.map((d) => (

                  <tr key={d.id}>

                    <td>

                      {d.nombre} {d.apellido}

                    </td>

                    <td>

                      {d.sede_nombre}

                    </td>

                    <td>

                      {d.grado}

                    </td>

                    <td>

                      {d.grupo}

                    </td>

                    <td>

                      {d.puede_notas === 1 && "📚 "}

                      {d.puede_asistencia === 1 && "📅 "}

                      {d.puede_observador === 1 && "📝 "}

                      {d.puede_convivencia === 1 && "⚖️ "}

                      {d.puede_financiero === 1 && "💰 "}

                      {d.puede_certificados === 1 && "📄 "}

                    </td>

                    <td>

                      <button

                        className="btn-editar"

                        onClick={() =>

                          editarPermisos(d)

                        }

                      >

                        ✏️

                      </button>

                      <button

                        className="btn-eliminar"

                        onClick={() =>

                          eliminar(d.id)

                        }

                      >

                        🗑

                      </button>

                    </td>

                  </tr>

                ))}

              </tbody>

            </table>

          </div>

        )}

      </div>

      {/* MODAL */}

      {editando && (

        <div className="director-modal">

          <div className="director-modal-card">

            <h3>Editar permisos</h3>

            {Object.keys(editando)

              .filter((k) => k !== "id")

              .map((campo) => (

                <label key={campo}>

                  <input

                    type="checkbox"

                    checked={editando[campo]}

                    onChange={() =>

                      setEditando((prev) => ({

                        ...prev,

                        [campo]:

                          !prev[campo],

                      }))

                    }

                  />

                  {campo}

                </label>

              ))}

            <div className="director-actions">

              <button

                className="btn-guardar"

                onClick={guardarPermisos}

              >

                💾 Guardar

              </button>

              <button

                onClick={() =>

                  setEditando(null)

                }

              >

                Cancelar

              </button>

            </div>

          </div>

        </div>

      )}

    </div>

  );
}